import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2, Download } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function SmartGardenPage() {
  const {
    t
  } = useLanguage();
  const advantages = [t('garden.adv1'), t('garden.adv2'), t('garden.adv3'), t('garden.adv4'), t('garden.adv5'), t('garden.adv6')];
  return <div className="w-full bg-white pb-32" data-id="element-687">
      <div className="bg-corporate-dark text-white py-24 md:py-40 px-4 relative overflow-hidden" data-id="element-688">
        <div className="absolute inset-0 opacity-20" data-id="element-689">
          <img src="https://cdn.magicpatterns.com/uploads/7wV2p5a1YK2rYfzjo16B6k/SmartGarden.png" alt="Background" className="w-full h-full object-cover" data-id="element-690" />
        </div>
        <div className="max-w-7xl mx-auto relative z-10 mt-10" data-id="element-691">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-692">
            <span className="text-accent-beige font-medium tracking-[0.2em] uppercase text-sm mb-6 block" data-id="element-693">
              {t('prod.line')}
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold mb-6 tracking-tight" data-id="element-694">
              SmartGarden
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-2xl font-light leading-relaxed" data-id="element-695">
              {t('garden.hero.desc')}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20 lg:mt-28" data-id="element-696">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20" data-id="element-697">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-698">
            <h2 className="text-4xl font-heading font-bold text-corporate-dark mb-8 tracking-tight" data-id="element-699">
              {t('garden.sec.title')}
            </h2>
            <div className="text-lg text-gray-600 font-light leading-relaxed space-y-6 mb-12" data-id="element-700">
              <p data-id="element-701">{t('garden.sec.p1')}</p>
              <p data-id="element-702">{t('garden.sec.p2')}</p>
            </div>

            <h3 className="text-2xl font-heading font-bold text-corporate-dark mb-8 tracking-tight" data-id="element-703">
              {t('prod.adv.title')}
            </h3>
            <ul className="space-y-5 mb-12" data-id="element-704">
              {advantages.map((adv, idx) => <li key={idx} className="flex items-start" data-id="element-705">
                  <CheckCircle2 className="h-6 w-6 text-corporate-blue mr-4 flex-shrink-0 mt-0.5" data-id="element-706" />
                  <span className="text-gray-700 text-lg font-light" data-id="element-707">
                    {adv}
                  </span>
                </li>)}
            </ul>

            <Link to="/descargables" className="inline-flex items-center px-8 py-4 bg-neutral-grey text-corporate-dark font-medium rounded-md hover:bg-gray-200 hover:scale-[1.02] transition-all duration-500 ease-premium" data-id="element-708">
              <Download className="mr-3 h-5 w-5" data-id="element-709" />
              {t('prod.dl.btn')}
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="space-y-8" data-id="element-710">
            <div className="h-96 bg-gray-100 rounded-sm overflow-hidden group" data-id="element-711">
              <img src="https://cdn.magicpatterns.com/uploads/7wV2p5a1YK2rYfzjo16B6k/SmartGarden.png" alt="Aplicación SmartGarden" className="w-full h-full object-cover transition-transform duration-700 ease-premium group-hover:scale-105" data-id="element-712" />
            </div>
            <div className="grid grid-cols-2 gap-8" data-id="element-713">
              <div className="bg-neutral-grey p-8 rounded-sm hover:shadow-md transition-all duration-500 ease-premium" data-id="element-714">
                <h4 className="text-xl font-heading font-bold text-corporate-dark mb-3 tracking-tight" data-id="element-715">
                  {t('garden.app1.title')}
                </h4>
                <p className="text-base text-gray-600 font-light leading-relaxed" data-id="element-716">
                  {t('garden.app1.desc')}
                </p>
              </div>
              <div className="bg-neutral-grey p-8 rounded-sm hover:shadow-md transition-all duration-500 ease-premium" data-id="element-717">
                <h4 className="text-xl font-heading font-bold text-corporate-dark mb-3 tracking-tight" data-id="element-718">
                  {t('garden.app2.title')}
                </h4>
                <p className="text-base text-gray-600 font-light leading-relaxed" data-id="element-719">
                  {t('garden.app2.desc')}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}